<template>
  <div id="app">
    <router-view />
    <notifications group="notify" />
    <vue-confirm-dialog/>
  </div>
</template>

<script>
import Header from "@/components/common/Header";

export default {
  name: "App",
  components: { Header }
};
</script>

<style>
@import url("../src/assets/font-awesome-4.7.0/css/font-awesome.min.css");
@import url("https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700");
@import url("https://fonts.googleapis.com/css?family=Roboto:400,300,500,700");

.img-fit {
  width: 100%;
  height: 100%;
  object-fit: fill;
}
*:focus,
button:focus {
  outline: none;
}

a {
  color: #337ab7;
  text-decoration: none;
}

* {
  font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
body {
  min-height: 100vh;
  background-image: linear-gradient(to bottom, #f9fbfd, #ffffff);
  font-size: 14px;
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background-color: #eee;
  border-radius: 0px;
}

::-webkit-scrollbar-thumb {
  height: 6px;
  border: 4px solid rgba(0, 0, 0, 0.5);
  background-clip: padding-box;
  border-radius: 0px;
  background-color: rgba(0, 0, 0, 0.5);
}

::-webkit-scrollbar-button {
  width: 0;
  height: 0;
  display: none;
}

::-webkit-scrollbar-corner {
  background-color: transparent;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.slick-slider .slick-arrow {
  position: absolute;
  top: 0;
  bottom: 0;
  background-color: transparent;
  z-index: 1;
  font-size: 0;
  border: none;
  width: 70px;
  color: #fff;
}

.slick-slider .slick-prev {
  left: 0;
}
.slick-slider .slick-next {
  right: 0;
}

.banner-right .slick-slider:hover .slick-prev {
  background-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0.3) 0,
    rgba(0, 0, 0, 0.0001) 100%
  );
  color: #ddd;
}

.banner-right .slick-slider:hover .slick-next {
  background-image: linear-gradient(
    to left,
    rgba(0, 0, 0, 0.3) 0,
    rgba(0, 0, 0, 0.0001) 100%
  );
  color: #ddd;
}

.slick-slider .slick-prev:before {
  content: "\f053";
  font-family: "FontAwesome";
  font-size: 25px;
}
.slick-slider .slick-next:before {
  content: "\f054";
  font-family: "FontAwesome";
  font-size: 25px;
}
.banner-right,
.banner-item,
.banner-right .slick-list {
  height: 400px;
}

.list-recommend .slick-next {
  right: -70px;
}
.list-recommend .slick-prev {
  left: -70px;
}

.list-recommend .slick-slider .slick-arrow {
  top: 50%;
  bottom: auto;
  color: #fff;
  transform: translateY(-50%);
}

.sku-dot-class {
  list-style: none;
  display: flex !important;
  justify-content: center;
  padding: 0;
  margin: 25px 0 0 0;
}

.sku-dot-class li button {
  color: transparent;
  height: 4px;
  width: 35px;
  margin: 0 7px;
  border: none;
  opacity: 0.5;
  background-color: #fff;
  opacity: 0.34;
}

.list-related .sku-dot-class li button {
  background-color: #3199bb;
}

.sku-dot-class li.slick-active button {
  opacity: 1;
}
a.btn-view-more {
  right: -15px;
  bottom: 10px;
  background-color: #3199bb;
  border-color: #3199bb;
  color: #fff !important;
}
a.btn-view-more:hover,
a.btn-view-more:focus,
a.btn-view-more:active {
  background-color: #fff !important;
  color: #3199bb !important;
  border-color: #3199bb !important;
  box-shadow: none !important;
}
.innovator-list {
  margin: auto !important;
}
.vue-rating-it ul li {
  color: #e07254 !important;
}

.vue-tabs .nav > li span.title {
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.75;
  letter-spacing: 0.13px;
  text-align: left;
  color: #1e242f;
  text-decoration: none;
  padding: 10px 20px;
  position: relative;
}
.vue-tabs .nav > li > a {
  padding: 0 !important;
  border: none !important;
  border-radius: 0 !important;
}

.vue-tabs .nav > li.active span.title {
  border-bottom: 3px solid #3199bb !important;
  color: #3199bb;
  font-weight: 600;
}

.vue-tabs .nav > li.active > a {
  border: none !important;
  background-color: transparent !important;
}
.modal-backdrop {
  opacity: 0.5;
}

.list-related .slick-slider .slick-arrow {
  top: 50%;
  bottom: auto;
  color: #3199bb;
}

.list-grid .page-item.disabled {
  display: none;
}

.list-grid .page-link {
  box-shadow: 0 16px 24px 0 rgba(50, 153, 186, 0.16);
  border: solid 1px #3199bb;
  background-color: #ffffff;
  color: #3199bb;
  /* border-radius: 50% !important; */
  border-radius: 999px!important;
  margin-left: 5px;
  padding: 0;
  /* width: 28px; */
  padding: 5px;
  min-width: 28px;
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 12px;
}

.list-grid .page-item.active .page-link {
  /* z-index: 3; */
  color: #fff;
  background-color: #3199bb;
  border-color: #3199bb;
}
.banner-item {
  /* background: url("~@/assets/images/landing/Login_computer.png"); */
  background-size: cover;
}

.dz-preview .dz-image img {
  max-width: 200px !important;
}

.v-select.add-width.vs--searchable .vs__dropdown-toggle .vs__selected-options {
  overflow: auto;
  max-height: 70px;
}

.btn-gray:not(a) {
  color: #5a6268 !important
}

#review-submission-domain-select .vs__selected {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 130px;
  display: flow-root;
}

#introduction .ck-read-only, #guideline .ck-read-only {
  height: auto;
  border: none !important;
}

#introduction .ck-editor__top, #guideline .ck-editor__top {
  display: none;
}

.search-box .v-select-option .vs__dropdown-toggle
 {
  min-width: 200px;
}

[type=button], [type=reset], [type=submit], button {
    -webkit-appearance: none;
}

  @media (max-width: 575.98px)
    {
      .banner-right,
      .banner-item,
      .banner-right .slick-list {
        height: 200px;
    }  
  }
  @media (min-width: 576px) and (max-width: 767.98px){
      .banner-right,
      .banner-item,
      .banner-right .slick-list {
        height: 250px;
    }
  }

  @media (min-width: 768px) and (max-width: 991.98px),
  (min-width: 992px) and (max-width: 1199.98px)
  {
    .banner-right,
    .banner-item,
    .banner-right .slick-list {
      height: 300px;
    }
  }

  @media (min-width: 1200px)
  {
    .banner-right,
    .banner-item,
    .banner-right .slick-list {
      height: 400px;
    }
  }
.dimension-tooltip{
	font-weight:bold;
	font-size:13px;
}
.dimension-tooltip-title{
	color:	#e07254;
}
.dimension{
	padding-bottom:10px;
}
.dimension-top-submissions{
	color:	#3199bb;
	font-size:9px;
	margin-bottom:2px;
	font-weight:bold;
}
.top-3-types tr td{
	font-weight:bold;
	font-size:13px;
	padding:2px 5px 0 0;  
}
.title-chart{
   background: -webkit-linear-gradient(#eee, #333);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.content-web{
  min-height: 81.9vh;
}
</style>



// WEBPACK FOOTER //
// src/App.vue